import BaseApi from '@/api/BaseApi'

export default class TreeApi extends BaseApi {
    async getTree (params = {
        organizationId: null,
        search: ''
    }) {
        return this.get('/api/v1.0/organizations/tree', {
            'OrganizationId': params.organizationId,
            'Search': params.search
        })
    }
}
